<template>
  <div :class="['main-navbar', 'bg-white', stickyTop ? 'sticky-top' : '']">
    <d-navbar type="light" class="align-items-stretch flex-md-nowrap p-0">
      <navbar-search />
      <branch-switcher />
      <navbar-nav />
      <navbar-toggle />
    </d-navbar>
    <notification-bar-message
      v-if="$store.state.settings.activeMembersCount > maxAllowedActiveMembers - 10"
      :message="
        $t('validations.exceedsLimitsForActiveMembers') +
        ' (' +
        $store.state.settings.activeMembersCount +
        '/' + maxAllowedActiveMembers +
        ') '
      "
    />
  </div>
</template>

<script>
import NotificationBarMessage from '@/components/Notification/NotificationBarMessage';
import NavbarSearch from './NavbarSearch.vue';
import NavbarNav from './NavbarNav.vue';
import NavbarToggle from './NavbarToggle.vue';
import BranchSwitcher from './BranchSwitcher.vue';

export default {
  components: {
    NavbarSearch,
    BranchSwitcher,
    NavbarNav,
    NavbarToggle,
    NotificationBarMessage,
  },
  props: {
    /**
     * Whether the main navbar should be sticky, or not.
     */
    stickyTop: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    maxAllowedActiveMembers() {
      const tenantSetting = this.$store.state.settings.tenantSetting || {};
      const base = parseInt(tenantSetting.maxNumberOfActiveMembers, 10) || 0;
      const addition = parseInt(tenantSetting.additionToMaxNumberOfActiveMembers, 10) || 0;
      return base + addition;
    },
  },
};
</script>

<style lang="scss">
.main-navbar {
  .dropdown-menu {
    display: block;
  }
}
</style>
